import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../config";

function PurchaseCancelled() {
  const navigate = useNavigate();

  // =============================
  // 🔓 Unlock listing if cancelled
  // =============================
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const listingId = params.get("listingId");

    if (listingId) {
      fetch(
        `${API_BASE_URL}/api/listings/${listingId}/unlock-if-pending`,
        { method: "POST" }
      ).catch((err) => console.error("Unlock error:", err));
    }
  }, []);

  const containerStyle = {
    maxWidth: "600px",
    margin: "40px auto",
    padding: "20px",
    background: "#fff",
    borderRadius: "12px",
    textAlign: "center",
    border: "1px solid #ddd",
    boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
  };

  const titleStyle = {
    fontSize: "26px",
    fontWeight: "bold",
    marginBottom: "15px",
    color: "#c62828",
  };

  const messageStyle = {
    fontSize: "16px",
    lineHeight: "1.6",
    marginBottom: "20px",
    color: "#555",
  };

  const buttonStyle = {
    padding: "12px 20px",
    backgroundColor: "#0288d1",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    fontSize: "16px",
    cursor: "pointer",
    marginTop: "10px",
    width: "100%",
  };

  return (
    <div style={containerStyle}>
      <h2 style={titleStyle}>Payment Cancelled</h2>

      <p style={messageStyle}>
        Your payment was not completed. No charges were made.
        <br />
        You can try again at any time.
      </p>

      <button style={buttonStyle} onClick={() => navigate("/listings")}>
        Back to Listings
      </button>
    </div>
  );
}

export default PurchaseCancelled;
